export enum DeviceTypes {
	Computer = 'Computer',
	Mobile = 'Mobile',
	Tablet = 'Tablet',
}

export type DeviceType = DeviceTypes.Computer | DeviceTypes.Mobile | DeviceTypes.Tablet;
